export const eventNames = {
  userClickedPrintStoreLink: 'userClickedPrintStoreLink',
  userClickedPrintItYourselfDropdownOption: 'userClickedPrintItYourselfDropdownOption',
  userClickedGetItPrintedDropdownOption: 'userClickedGetItPrintedDropdownOption',
  userClickedPrintDropdown: 'userClickedPrintDropdown',
  userSelectedProductQuantity: 'userSelectedProductQuantity',
  userEnteredValidZipcode: 'userEnteredValidZipcode',
  userEnteredInvalidZipcode: 'userEnteredInvalidZipcode',
  userEnteredEmptyZipcode: 'userEnteredEmptyZipcode',
  userClickedBackToPrintStoreButton: 'userClickedBackToPrintStoreButton',
  userClickedBackToCodeButton: 'userClickedBackToCodeButton',
  userClickedContactUsButton: 'userClickedContactUsButton',
  userClickedGetItPrintedDrawer: 'userClickedGetItPrintedDrawer',
  userClickedPrintItYourselfDrawer: 'userClickedPrintItYourselfDrawer',
  userClickedCheckoutButton: 'userClickedCheckoutButton',
  userClickedPrintStoreSurveyCard: 'userClickedPrintStoreSurveyCard',
  userClickedPrintStoreProductCard: 'userClickedPrintStoreProductCard',
  userSelectedShippingOption: 'userSelectedShippingOption',
  Print_Store_Cart_Selected_Handling_Option: 'Print_Store_Cart_Selected_Handling_Option',
  userClickedSignInAndPrintCode: 'userClickedSignInAndPrintCode',
  userHoveredOverHowToUseSection: 'userHoveredOverHowToUseSection',
  userHoveredOverStickerPhotosSection: 'userHoveredOverStickerPhotosSection',
  userClickedCreateFlowcodeButton: 'userClickedCreateFlowcodeButton',
  userClickedCreateFlowcodeButtonFromModal: 'userClickedCreateFlowcodeButtonFromModal',
  userClickedSelectFlowcodeButton: 'userClickedSelectFlowcodeButton',
  userSelectedFlowcodeToPrint: 'userSelectedFlowcodeToPrint',
  Print_Store_PDP_Removed_Selected_Code: 'Print_Store_PDP_Removed_Selected_Code',
  Print_Store_PDP_Selected_Product_Quantity: 'Print_Store_PDP_Selected_Product_Quantity',
  Print_Store_PDP_Clicked_Back_Button: 'Print_Store_PDP_Clicked_Back_Button',
  Print_Store_PDP_Clicked_View_Cart_Button: 'Print_Store_PDP_Clicked_View_Cart_Button',
  Print_Store_PDP_Added_Item: 'Print_Store_PDP_Added_Item',
  userClickedPrintStoreHeroStickers: 'userClickedPrintStoreHeroStickers',
  userClickedPrintStoreHeroBusinessCards: 'userClickedPrintStoreHeroBusinessCards',
  userClickedPrintStoreHeroTableTents: 'userClickedPrintStoreHeroTableTents',
  Print_Store_Homepage_Clicked_Print_Store_FAQs_Btn:
    'Print_Store_Homepage_Clicked_Print_Store_FAQs_Btn',
  Print_Store_Analytics_Clicked_Business_Cards_Card:
    'Print_Store_Analytics_Clicked_Business_Cards_Card',
  Print_Store_Analytics_Clicked_Table_Tents_Card: 'Print_Store_Analytics_Clicked_Table_Tents_Card',
  Print_Store_Analytics_Clicked_Coasters_Card: 'Print_Store_Analytics_Clicked_Coasters_Card',
  Print_Store_Analytics_Clicked_Stickers_Card: 'Print_Store_Analytics_Clicked_Stickers_Card',
  userClickedPrintStoreUpsell: 'userClickedPrintStoreUpsell',
  userClickedPredesignedFlowtagProduct: 'userClickedPredesignedFlowtagProduct',
  Print_Store_Analytics_Clicked_Predesigned_Flowtag:
    'Print_Store_Analytics_Clicked_Predesigned_Flowtag',
  Flowcode_Store_Categories_Clicked_Category_Card:
    'Flowcode_Store_Categories_Clicked_Category_Card',
  Flowcode_Store_Clicked_Bottom_Banner_Get_Flowtag_Btn:
    'Flowcode_Store_Clicked_Bottom_Banner_Get_Flowtag_Btn',
  Flowcode_Store_Products_Clicked_See_All: 'Flowcode_Store_Products_Clicked_See_All',

  // Templates page Brand Kit form
  PrintTemplates_Templates_Brand_Kit_Selected_Flowcode:
    'PrintTemplates_Templates_Brand_Kit_Selected_Flowcode',
  PrintTemplates_Templates_Brand_Kit_Removed_Flowcode:
    'PrintTemplates_Templates_Brand_Kit_Removed_Flowcode',
  PrintTemplates_Templates_Brand_Kit_Entered_CTA: 'PrintTemplates_Templates_Brand_Kit_Entered_CTA',
  PrintTemplates_Templates_Brand_Kit_Added_Logo: 'PrintTemplates_Templates_Brand_Kit_Added_Logo',
  PrintTemplates_Templates_Brand_Kit_Removed_Logo:
    'PrintTemplates_Templates_Brand_Kit_Removed_Logo',
  PrintTemplates_Templates_Brand_Kit_Selected_Primary_Color:
    'PrintTemplates_Templates_Brand_Kit_Selected_Primary_Color',
  PrintTemplates_Templates_Brand_Kit_Selected_Secondary_Color:
    'PrintTemplates_Templates_Brand_Kit_Selected_Secondary_Color',
  PrintTemplates_Templates_Brand_Kit_Clicked_Update:
    'PrintTemplates_Templates_Brand_Kit_Clicked_Update',

  PrintTemplates_TemplateEditor_clicked_downloadbutton:
    'PrintTemplates_TemplateEditor_clicked_downloadbutton',
  PrintTemplates_TemplateEditor_DownloadModal_clicked_download:
    'PrintTemplates_TemplateEditor_DownloadModal_clicked_download',
  PrintTemplates_TemplateEditor_DownloadModal_clicked_order:
    'PrintTemplates_TemplateEditor_DownloadModal_clicked_order',
  PrintTemplates_TemplateEditor_DownloadModal_clicked_email:
    'PrintTemplates_TemplateEditor_DownloadModal_clicked_email',
  PrintTemplates_TemplateEditor_DownloadModal_clicked_print:
    'PrintTemplates_TemplateEditor_DownloadModal_clicked_print',
  PrintTemplates_TemplateEditor_EmailModal_clicked_close:
    'PrintTemplates_TemplateEditor_EmailModal_clicked_close',
  PrintTemplates_TemplateEditor_EmailModal_clicked_submit:
    'PrintTemplates_TemplateEditor_EmailModal_clicked_submit',
  PrintTemplates_Templates_Brand_Kit_Clicked_Create_Flowcode:
    'PrintTemplates_Templates_Brand_Kit_Clicked_Create_Flowcode',
  PrintTemplates_Templates_Brand_Kit_Clicked_Select_Flowcode:
    'PrintTemplates_Templates_Brand_Kit_Clicked_Select_Flowcode'
}

export default eventNames
